

(function () {
  function init(root) {
    if (!root || root.dataset.csKvInit) { return; }
    root.dataset.csKvInit = '1';

    var stage = root.querySelector('[data-cs-kv-stage]');
    if (!stage) { return; }
    var vid = stage.querySelector('video');
    if (!vid) { return; }

    var cover = stage.querySelector('[data-cs-kv-trigger]');
    var banner = stage.querySelector('[data-cs-kv-unmute]');
    var controls = stage.querySelector('[data-cs-kv-controls]');
    var playBtn = stage.querySelector('[data-cs-kv-playbtn]');
    var playIcon = stage.querySelector('[data-cs-kv-playicon]');
    var pauseIcon = stage.querySelector('[data-cs-kv-pauseicon]');
    var muteBtn = stage.querySelector('[data-cs-kv-mutebtn]');
    var mutedIcon = stage.querySelector('[data-cs-kv-mutedicon]');
    var unmutedIcon = stage.querySelector('[data-cs-kv-unmutedicon]');
    var progress = stage.querySelector('[data-cs-kv-progress]');
    var progressFill = stage.querySelector('[data-cs-kv-progressfill]');
    var auto = stage.hasAttribute('data-cs-kv-auto');

    function inside(node, target) {
      return !!node && (node === target || node.contains(target));
    }

    
    function play() {
      var p = vid.play();
      if (p && p.catch) {
        p.catch(function () {
          setTimeout(function () {
            var again = vid.play();
            if (again && again.catch) { again.catch(function () {}); }
          }, 60);
        });
      }
    }

    function syncPlay() {
      if (playIcon) { playIcon.style.display = vid.paused ? 'block' : 'none'; }
      if (pauseIcon) { pauseIcon.style.display = vid.paused ? 'none' : 'block'; }
      if (playBtn) { playBtn.setAttribute('aria-label', vid.paused ? root.dataset.playLabel : root.dataset.pauseLabel); }
    }

    function syncMute() {
      if (mutedIcon) { mutedIcon.style.display = vid.muted ? 'block' : 'none'; }
      if (unmutedIcon) { unmutedIcon.style.display = vid.muted ? 'none' : 'block'; }
      if (muteBtn) { muteBtn.setAttribute('aria-label', vid.muted ? root.dataset.unmuteLabel : root.dataset.muteLabel); }
      
      if (banner) { banner.classList.toggle('cs-kv-hidden', !vid.muted); }
    }

    function unmuteTap(e) {
      e.preventDefault();
      e.stopPropagation();
      vid.muted = false;
      syncMute();
      play();
    }

    if (banner) {
      banner.addEventListener('pointerdown', unmuteTap);
      banner.addEventListener('click', unmuteTap);
    }

    
    if (cover) {
      cover.addEventListener('click', function () {
        stage.classList.add('cs-kv-playing');
        try { vid.setAttribute('controls', ''); } catch (err) {}
        play();
        try { vid.focus(); } catch (err) {}
      });
    }

    if (!auto) {
      syncPlay();
      return;
    }

    try {
      vid.setAttribute('disableremoteplayback', '');
      vid.setAttribute('controlslist', 'noremoteplayback');
      vid.setAttribute('x-webkit-airplay', 'deny');
    } catch (err) {}

    function togglePlay() {
      if (vid.paused) {
        play();
      } else {
        vid.volume = 0; 
        vid.pause();
        vid.volume = 1; 
      }
    }

    
    var lastPointer = 0;
    stage.addEventListener('pointerdown', function (e) {
      var t = e.target;
      lastPointer = Date.now();

      if (inside(banner, t)) { e.preventDefault(); return; }

      if (inside(muteBtn, t)) {
        vid.muted = !vid.muted;
        syncMute();
        e.preventDefault();
        return;
      }

      if (inside(progress, t)) {
        var rect = progress.getBoundingClientRect();
        if (vid.duration && rect.width) {
          var ratio = (e.clientX - rect.left) / rect.width;
          if (ratio < 0) { ratio = 0; }
          if (ratio > 1) { ratio = 1; }
          vid.currentTime = ratio * vid.duration;
        }
        e.preventDefault();
        return;
      }

      
      togglePlay();
      e.preventDefault();
    });

    
    function keyboardOnly(fn) {
      return function (e) {
        if (Date.now() - lastPointer < 500) { return; }
        fn();
        e.preventDefault();
      };
    }
    if (playBtn) { playBtn.addEventListener('click', keyboardOnly(togglePlay)); }
    if (muteBtn) {
      muteBtn.addEventListener('click', keyboardOnly(function () {
        vid.muted = !vid.muted;
        syncMute();
      }));
    }

    vid.addEventListener('play', syncPlay);
    vid.addEventListener('pause', syncPlay);
    vid.addEventListener('timeupdate', function () {
      if (progressFill && vid.duration) {
        progressFill.style.width = (vid.currentTime / vid.duration) * 100 + '%';
      }
    });

    
    if (controls) {
      controls.classList.add('cs-kv-visible');
      setTimeout(function () { controls.classList.remove('cs-kv-visible'); }, 3000);
    }

    syncPlay();
    syncMute();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cs-kv-root]');
    Array.prototype.forEach.call(roots, init);
    if (scope && scope.hasAttribute && scope.hasAttribute('data-cs-kv-root')) { init(scope); }
  }

  initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();


if (!customElements.get('cs-review-carousel')) {
  customElements.define('cs-review-carousel', class extends HTMLElement {
    static selectedBlocks = new Map();
    connectedCallback() {
      this.editorController?.abort();
      this.editorController = new AbortController();
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          const sectionId = event.detail?.sectionId;
          if (sectionId && sectionId !== this.dataset.reviewSectionId) return;
          const card = event.target.closest?.('[data-review-card]');
          if (!sectionId && (!card || !this.contains(card))) return;
          const blockId = card?.dataset.reviewBlockId || event.detail?.blockId;
          if (!blockId) return;
          this.constructor.selectedBlocks.set(this.dataset.reviewSectionId, String(blockId));
          this.showSelectedBlock();
        }, { capture: true, signal: this.editorController.signal });
      }
      this.frame = requestAnimationFrame(() => this.setup());
    }
    showSelectedBlock() {
      if (!window.Shopify?.designMode) return;
      const selectedId = this.constructor.selectedBlocks.get(this.dataset.reviewSectionId);
      if (!selectedId) return;
      const track = this.querySelector('[data-review-track]');
      const card = [...this.querySelectorAll('[data-review-card]')].find(item => {
        const id = item.dataset.reviewBlockId;
        return id && (selectedId === id || selectedId.endsWith('__' + id));
      });
      if (track && card) track.scrollTo({ left: Math.max(0, card.offsetLeft - 2), behavior: 'instant' });
    }
    setup() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('[data-review-track]');
      const cards = [...this.querySelectorAll('[data-review-card]')];
      const controls = this.querySelector('[data-review-controls]');
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const page = this.querySelector('[data-review-page]');
      if (!track || !cards.length) return;
      let index = 0;
      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        index = cards.reduce((best, card, i) => Math.abs(Math.min(Math.max(0, card.offsetLeft - 2), maxScroll) - track.scrollLeft) < Math.abs(Math.min(Math.max(0, cards[best].offsetLeft - 2), maxScroll) - track.scrollLeft) ? i : best, 0);
        controls.hidden = cards.length < 2 || track.scrollWidth <= track.clientWidth + 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        page.textContent = `${index + 1} / ${cards.length}`;
      };
      const go = i => track.scrollTo({ left: cards[Math.max(0, Math.min(cards.length - 1, i))].offsetLeft - 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      previous.addEventListener('click', () => go(index - 1), options);
      next.addEventListener('click', () => go(index + 1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      let drag = null;
      track.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0 || event.target.closest('button,a,input,video')) return;
        drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, target: track.scrollLeft, moved: false };
        track.setPointerCapture(event.pointerId);
        track.focus({ preventScroll: true });
        event.preventDefault();
      }, options);
      track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (Math.abs(event.clientX - drag.x) > 4) drag.moved = true;
        if (!drag.moved) return;
        track.classList.add('is-dragging');
        drag.target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, drag.left + drag.x - event.clientX));
        track.scrollLeft = drag.target;
        event.preventDefault();
      }, options);
      const finishDrag = event => {
        if (!drag || event.pointerId !== drag.id) return;
        const moved = drag.moved;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const destination = cards.reduce((best, card, i) => Math.abs(Math.min(Math.max(0, card.offsetLeft - 2), maxScroll) - drag.target) < Math.abs(Math.min(Math.max(0, cards[best].offsetLeft - 2), maxScroll) - drag.target) ? i : best, 0);
        drag = null;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        if (moved) requestAnimationFrame(() => go(destination));
      };
      track.addEventListener('pointerup', finishDrag, options);
      track.addEventListener('pointercancel', finishDrag, options);
      track.addEventListener('dragstart', event => event.preventDefault(), options);
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
        if (event.key === 'Home') { event.preventDefault(); go(0); }
        if (event.key === 'End') { event.preventDefault(); go(cards.length - 1); }
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      this.showSelectedBlock();
      update();
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.editorController?.abort(); this.observer?.disconnect(); }
  });
}
